import ClientsAxios from '../../client-axios';
import { ResponseEntity } from '../../dto/response';

const { API_SERVER } = ClientsAxios;


export const StoreEPCGLincenseService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('epcg-license-master/store', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const UpdateEPCGLincenseService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('epcg-license-master/update', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const DeleteEPCGLincenseService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('epcg-license-master/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchEPCGLincenseListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('epcg-license-master/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}


// Advance master List 
export const StoreAdvanceLincenseService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('advance-license-master/store', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const UpdateAdvanceLincenseService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('advance-license-master/update', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const DeleteAdvanceLincenseService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('advance-license-master/delete', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchAdvanceLincenseListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('advance-license-master/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.Message, response?.data?.body || {})
    }
    return responseEntity
}